<div id="canvasArea">
  <div
    id="oie-canvas"
    :style="getCanvasDim"
    :class="{marginView: getEditor.marginView}"
    ref="oieCanvasRef"
  >
    <appImageContainer></appImageContainer>
    <appFormatEditor></appFormatEditor>
  </div>
</div>
